import { jsxs as u, jsx as o, Fragment as te } from "react/jsx-runtime";
import at, { forwardRef as Ce, useId as it, useRef as ce, useEffect as de, useState as ae, useMemo as J, useCallback as ne } from "react";
function De(e) {
  var n, t, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (n = 0; n < i; n++) e[n] && (t = De(e[n])) && (r && (r += " "), r += t);
  } else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Ve() {
  for (var e, n, t = 0, r = "", i = arguments.length; t < i; t++) (e = arguments[t]) && (n = De(e)) && (r && (r += " "), r += n);
  return r;
}
const Fe = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, je = Ve, xe = (e, n) => (t) => {
  var r;
  if ((n == null ? void 0 : n.variants) == null) return je(e, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: i, defaultVariants: s } = n, a = Object.keys(i).map((d) => {
    const p = t == null ? void 0 : t[d], g = s == null ? void 0 : s[d];
    if (p === null) return null;
    const k = Fe(p) || Fe(g);
    return i[d][k];
  }), l = t && Object.entries(t).reduce((d, p) => {
    let [g, k] = p;
    return k === void 0 || (d[g] = k), d;
  }, {}), c = n == null || (r = n.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, p) => {
    let { class: g, className: k, ...y } = p;
    return Object.entries(y).every((A) => {
      let [N, w] = A;
      return Array.isArray(w) ? w.includes({
        ...s,
        ...l
      }[N]) : {
        ...s,
        ...l
      }[N] === w;
    }) ? [
      ...d,
      g,
      k
    ] : d;
  }, []);
  return je(e, a, c, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, st = (e, n) => {
  const t = new Array(e.length + n.length);
  for (let r = 0; r < e.length; r++)
    t[r] = e[r];
  for (let r = 0; r < n.length; r++)
    t[e.length + r] = n[r];
  return t;
}, lt = (e, n) => ({
  classGroupId: e,
  validator: n
}), $e = (e = /* @__PURE__ */ new Map(), n = null, t) => ({
  nextPart: e,
  validators: n,
  classGroupId: t
}), pe = "-", Re = [], ct = "arbitrary..", dt = (e) => {
  const n = ut(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return mt(a);
      const l = a.split(pe), c = l[0] === "" && l.length > 1 ? 1 : 0;
      return _e(l, c, n);
    },
    getConflictingClassGroupIds: (a, l) => {
      if (l) {
        const c = r[a], d = t[a];
        return c ? d ? st(d, c) : c : d || Re;
      }
      return t[a] || Re;
    }
  };
}, _e = (e, n, t) => {
  if (e.length - n === 0)
    return t.classGroupId;
  const i = e[n], s = t.nextPart.get(i);
  if (s) {
    const d = _e(e, n + 1, s);
    if (d) return d;
  }
  const a = t.validators;
  if (a === null)
    return;
  const l = n === 0 ? e.join(pe) : e.slice(n).join(pe), c = a.length;
  for (let d = 0; d < c; d++) {
    const p = a[d];
    if (p.validator(l))
      return p.classGroupId;
  }
}, mt = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const n = e.slice(1, -1), t = n.indexOf(":"), r = n.slice(0, t);
  return r ? ct + r : void 0;
})(), ut = (e) => {
  const {
    theme: n,
    classGroups: t
  } = e;
  return ft(t, n);
}, ft = (e, n) => {
  const t = $e();
  for (const r in e) {
    const i = e[r];
    Ae(i, t, r, n);
  }
  return t;
}, Ae = (e, n, t, r) => {
  const i = e.length;
  for (let s = 0; s < i; s++) {
    const a = e[s];
    ht(a, n, t, r);
  }
}, ht = (e, n, t, r) => {
  if (typeof e == "string") {
    bt(e, n, t);
    return;
  }
  if (typeof e == "function") {
    pt(e, n, t, r);
    return;
  }
  xt(e, n, t, r);
}, bt = (e, n, t) => {
  const r = e === "" ? n : Oe(n, e);
  r.classGroupId = t;
}, pt = (e, n, t, r) => {
  if (gt(e)) {
    Ae(e(r), n, t, r);
    return;
  }
  n.validators === null && (n.validators = []), n.validators.push(lt(t, e));
}, xt = (e, n, t, r) => {
  const i = Object.entries(e), s = i.length;
  for (let a = 0; a < s; a++) {
    const [l, c] = i[a];
    Ae(c, Oe(n, l), t, r);
  }
}, Oe = (e, n) => {
  let t = e;
  const r = n.split(pe), i = r.length;
  for (let s = 0; s < i; s++) {
    const a = r[s];
    let l = t.nextPart.get(a);
    l || (l = $e(), t.nextPart.set(a, l)), t = l;
  }
  return t;
}, gt = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, vt = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let n = 0, t = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const i = (s, a) => {
    t[s] = a, n++, n > e && (n = 0, r = t, t = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let a = t[s];
      if (a !== void 0)
        return a;
      if ((a = r[s]) !== void 0)
        return i(s, a), a;
    },
    set(s, a) {
      s in t ? t[s] = a : i(s, a);
    }
  };
}, ke = "!", Se = ":", yt = [], Te = (e, n, t, r, i) => ({
  modifiers: e,
  hasImportantModifier: n,
  baseClassName: t,
  maybePostfixModifierPosition: r,
  isExternal: i
}), wt = (e) => {
  const {
    prefix: n,
    experimentalParseClassName: t
  } = e;
  let r = (i) => {
    const s = [];
    let a = 0, l = 0, c = 0, d;
    const p = i.length;
    for (let N = 0; N < p; N++) {
      const w = i[N];
      if (a === 0 && l === 0) {
        if (w === Se) {
          s.push(i.slice(c, N)), c = N + 1;
          continue;
        }
        if (w === "/") {
          d = N;
          continue;
        }
      }
      w === "[" ? a++ : w === "]" ? a-- : w === "(" ? l++ : w === ")" && l--;
    }
    const g = s.length === 0 ? i : i.slice(c);
    let k = g, y = !1;
    g.endsWith(ke) ? (k = g.slice(0, -1), y = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      g.startsWith(ke) && (k = g.slice(1), y = !0)
    );
    const A = d && d > c ? d - c : void 0;
    return Te(s, y, k, A);
  };
  if (n) {
    const i = n + Se, s = r;
    r = (a) => a.startsWith(i) ? s(a.slice(i.length)) : Te(yt, !1, a, void 0, !0);
  }
  if (t) {
    const i = r;
    r = (s) => t({
      className: s,
      parseClassName: i
    });
  }
  return r;
}, kt = (e) => {
  const n = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((t, r) => {
    n.set(t, 1e6 + r);
  }), (t) => {
    const r = [];
    let i = [];
    for (let s = 0; s < t.length; s++) {
      const a = t[s], l = a[0] === "[", c = n.has(a);
      l || c ? (i.length > 0 && (i.sort(), r.push(...i), i = []), r.push(a)) : i.push(a);
    }
    return i.length > 0 && (i.sort(), r.push(...i)), r;
  };
}, Nt = (e) => ({
  cache: vt(e.cacheSize),
  parseClassName: wt(e),
  sortModifiers: kt(e),
  ...dt(e)
}), Ct = /\s+/, At = (e, n) => {
  const {
    parseClassName: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: s
  } = n, a = [], l = e.trim().split(Ct);
  let c = "";
  for (let d = l.length - 1; d >= 0; d -= 1) {
    const p = l[d], {
      isExternal: g,
      modifiers: k,
      hasImportantModifier: y,
      baseClassName: A,
      maybePostfixModifierPosition: N
    } = t(p);
    if (g) {
      c = p + (c.length > 0 ? " " + c : c);
      continue;
    }
    let w = !!N, z = r(w ? A.substring(0, N) : A);
    if (!z) {
      if (!w) {
        c = p + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (z = r(A), !z) {
        c = p + (c.length > 0 ? " " + c : c);
        continue;
      }
      w = !1;
    }
    const F = k.length === 0 ? "" : k.length === 1 ? k[0] : s(k).join(":"), M = y ? F + ke : F, O = M + z;
    if (a.indexOf(O) > -1)
      continue;
    a.push(O);
    const G = i(z, w);
    for (let C = 0; C < G.length; ++C) {
      const W = G[C];
      a.push(M + W);
    }
    c = p + (c.length > 0 ? " " + c : c);
  }
  return c;
}, zt = (...e) => {
  let n = 0, t, r, i = "";
  for (; n < e.length; )
    (t = e[n++]) && (r = Ge(t)) && (i && (i += " "), i += r);
  return i;
}, Ge = (e) => {
  if (typeof e == "string")
    return e;
  let n, t = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (n = Ge(e[r])) && (t && (t += " "), t += n);
  return t;
}, Mt = (e, ...n) => {
  let t, r, i, s;
  const a = (c) => {
    const d = n.reduce((p, g) => g(p), e());
    return t = Nt(d), r = t.cache.get, i = t.cache.set, s = l, l(c);
  }, l = (c) => {
    const d = r(c);
    if (d)
      return d;
    const p = At(c, t);
    return i(c, p), p;
  };
  return s = a, (...c) => s(zt(...c));
}, It = [], E = (e) => {
  const n = (t) => t[e] || It;
  return n.isThemeGetter = !0, n;
}, Pe = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, He = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Lt = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Ft = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, jt = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Rt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, St = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Tt = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, U = (e) => Lt.test(e), v = (e) => !!e && !Number.isNaN(Number(e)), ee = (e) => !!e && Number.isInteger(Number(e)), ye = (e) => e.endsWith("%") && v(e.slice(0, -1)), Q = (e) => Ft.test(e), Xe = () => !0, Bt = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  jt.test(e) && !Rt.test(e)
), ze = () => !1, Wt = (e) => St.test(e), Et = (e) => Tt.test(e), Dt = (e) => !f(e) && !h(e), Vt = (e) => re(e, Ke, ze), f = (e) => Pe.test(e), oe = (e) => re(e, Qe, Bt), Be = (e) => re(e, Yt, v), $t = (e) => re(e, Ze, Xe), _t = (e) => re(e, Je, ze), We = (e) => re(e, Ye, ze), Ot = (e) => re(e, qe, Et), he = (e) => re(e, Ue, Wt), h = (e) => He.test(e), le = (e) => ie(e, Qe), Gt = (e) => ie(e, Je), Ee = (e) => ie(e, Ye), Pt = (e) => ie(e, Ke), Ht = (e) => ie(e, qe), be = (e) => ie(e, Ue, !0), Xt = (e) => ie(e, Ze, !0), re = (e, n, t) => {
  const r = Pe.exec(e);
  return r ? r[1] ? n(r[1]) : t(r[2]) : !1;
}, ie = (e, n, t = !1) => {
  const r = He.exec(e);
  return r ? r[1] ? n(r[1]) : t : !1;
}, Ye = (e) => e === "position" || e === "percentage", qe = (e) => e === "image" || e === "url", Ke = (e) => e === "length" || e === "size" || e === "bg-size", Qe = (e) => e === "length", Yt = (e) => e === "number", Je = (e) => e === "family-name", Ze = (e) => e === "number" || e === "weight", Ue = (e) => e === "shadow", qt = () => {
  const e = E("color"), n = E("font"), t = E("text"), r = E("font-weight"), i = E("tracking"), s = E("leading"), a = E("breakpoint"), l = E("container"), c = E("spacing"), d = E("radius"), p = E("shadow"), g = E("inset-shadow"), k = E("text-shadow"), y = E("drop-shadow"), A = E("blur"), N = E("perspective"), w = E("aspect"), z = E("ease"), F = E("animate"), M = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], O = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], G = () => [...O(), h, f], C = () => ["auto", "hidden", "clip", "visible", "scroll"], W = () => ["auto", "contain", "none"], b = () => [h, f, c], I = () => [U, "full", "auto", ...b()], j = () => [ee, "none", "subgrid", h, f], $ = () => ["auto", {
    span: ["full", ee, h, f]
  }, ee, h, f], S = () => [ee, "auto", h, f], R = () => ["auto", "min", "max", "fr", h, f], P = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], X = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], V = () => ["auto", ...b()], Y = () => [U, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...b()], x = () => [U, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...b()], B = () => [U, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...b()], m = () => [e, h, f], K = () => [...O(), Ee, We, {
    position: [h, f]
  }], Z = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], q = () => ["auto", "cover", "contain", Pt, Vt, {
    size: [h, f]
  }], se = () => [ye, le, oe], T = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    h,
    f
  ], L = () => ["", v, le, oe], H = () => ["solid", "dashed", "dotted", "double"], Ie = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], D = () => [v, ye, Ee, We], Le = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    A,
    h,
    f
  ], me = () => ["none", v, h, f], ue = () => ["none", v, h, f], ve = () => [v, h, f], fe = () => [U, "full", ...b()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Q],
      breakpoint: [Q],
      color: [Xe],
      container: [Q],
      "drop-shadow": [Q],
      ease: ["in", "out", "in-out"],
      font: [Dt],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Q],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Q],
      shadow: [Q],
      spacing: ["px", v],
      text: [Q],
      "text-shadow": [Q],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", U, f, h, w]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [v, f, h, l]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": M()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": M()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: G()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: W()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": W()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": W()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: I()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": I()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": I()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": I(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: I()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": I(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: I()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": I()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": I()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: I()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: I()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: I()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: I()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [ee, "auto", h, f]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [U, "full", "auto", l, ...b()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [v, U, "auto", "initial", "none", f]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", v, h, f]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", v, h, f]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [ee, "first", "last", "none", h, f]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": j()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: $()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": S()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": S()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": j()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: $()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": S()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": S()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": R()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": R()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: b()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": b()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": b()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...P(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...X(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...X()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...P()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...X(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...X(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": P()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...X(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...X()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: b()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: b()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: b()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: b()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: b()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: b()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: b()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: b()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: b()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: b()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: b()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: V()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: V()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: V()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: V()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: V()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: V()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: V()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: V()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: V()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: V()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: V()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": b()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": b()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Y()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...x()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...x()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...x()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...B()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...B()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...B()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [l, "screen", ...Y()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          l,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Y()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          l,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...Y()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Y()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Y()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Y()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", t, le, oe]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, Xt, $t]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", ye, f]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Gt, _t, n]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [f]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, h, f]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [v, "none", h, Be]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...b()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", h, f]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", h, f]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: m()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: m()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...H(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [v, "from-font", "auto", h, oe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: m()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [v, "auto", h, f]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: b()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", h, f]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", h, f]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: K()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Z()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: q()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, ee, h, f],
          radial: ["", h, f],
          conic: [ee, h, f]
        }, Ht, Ot]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: m()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: se()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: se()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: se()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: m()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: m()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: m()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: T()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": T()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": T()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": T()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": T()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": T()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": T()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": T()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": T()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": T()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": T()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": T()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": T()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": T()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": T()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: L()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": L()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": L()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": L()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": L()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": L()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": L()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": L()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": L()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": L()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": L()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": L()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": L()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...H(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...H(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: m()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": m()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": m()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": m()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": m()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": m()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": m()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": m()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": m()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": m()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": m()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: m()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...H(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [v, h, f]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", v, le, oe]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: m()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          be,
          he
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: m()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", g, be, he]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": m()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: L()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: m()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [v, oe]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": m()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": L()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": m()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", k, be, he]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": m()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v, h, f]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Ie(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ie()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [v]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": D()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": D()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": m()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": m()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": D()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": D()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": m()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": m()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": D()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": D()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": m()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": m()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": D()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": D()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": m()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": m()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": D()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": D()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": m()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": m()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": D()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": D()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": m()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": m()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": D()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": D()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": m()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": m()
      }],
      "mask-image-radial": [{
        "mask-radial": [h, f]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": D()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": D()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": m()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": m()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": O()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [v]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": D()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": D()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": m()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": m()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: K()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Z()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: q()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", h, f]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          h,
          f
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Le()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [v, h, f]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [v, h, f]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          y,
          be,
          he
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": m()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", v, h, f]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [v, h, f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", v, h, f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [v, h, f]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", v, h, f]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          h,
          f
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Le()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [v, h, f]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [v, h, f]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", v, h, f]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [v, h, f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", v, h, f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v, h, f]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [v, h, f]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", v, h, f]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": b()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": b()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": b()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", h, f]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [v, "initial", h, f]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", z, h, f]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [v, h, f]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", F, h, f]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [N, h, f]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": G()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: me()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": me()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": me()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": me()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ue()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ue()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ue()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ue()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ve()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ve()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ve()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [h, f, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: G()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: fe()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": fe()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": fe()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": fe()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: m()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: m()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", h, f]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": b()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": b()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": b()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": b()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": b()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": b()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": b()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": b()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": b()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": b()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": b()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": b()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": b()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": b()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": b()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": b()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": b()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": b()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": b()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": b()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": b()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": b()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", h, f]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...m()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [v, le, oe, Be]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...m()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Kt = /* @__PURE__ */ Mt(qt);
function _(...e) {
  return Kt(Ve(e));
}
const Qt = xe(
  [
    "inline-flex items-center justify-center gap-2",
    "font-ui font-medium",
    "transition-colors duration-150",
    "rounded-m",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus",
    "disabled:opacity-disabled disabled:pointer-events-none",
    "cursor-pointer"
  ],
  {
    variants: {
      variant: {
        primary: "bg-accent-primary text-accent-on-primary hover:bg-accent-primary-hover active:bg-accent-primary-pressed",
        secondary: "bg-accent-secondary text-accent-on-secondary border border-border-default hover:bg-accent-secondary-hover active:bg-accent-secondary-pressed",
        ghost: "bg-transparent text-accent-primary hover:bg-surface-dim active:bg-surface-extra-dim"
      },
      size: {
        sm: "h-8 px-3 text-body-sm",
        md: "h-10 px-4 text-body-md",
        lg: "h-12 px-6 text-body-lg"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), Jt = Ce(
  ({ className: e, variant: n, size: t, icon: r, iconPosition: i = "left", children: s, ...a }, l) => /* @__PURE__ */ u(
    "button",
    {
      ref: l,
      className: _(Qt({ variant: n, size: t }), e),
      ...a,
      children: [
        r && i === "left" && /* @__PURE__ */ o("span", { className: "shrink-0", children: r }),
        s,
        r && i === "right" && /* @__PURE__ */ o("span", { className: "shrink-0", children: r })
      ]
    }
  )
);
Jt.displayName = "Button";
const Zt = xe(
  [
    "w-full rounded-m bg-surface-default",
    "border border-border-default",
    "px-3 py-2 text-body-md font-ui text-text-default",
    "transition-colors duration-150",
    "placeholder:text-text-weakest",
    "hover:border-border-strong",
    "focus:outline-none focus:border-border-focus",
    "disabled:opacity-disabled disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        default: "",
        error: "border-semantic-danger focus:border-semantic-danger"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), Ut = Ce(
  ({ className: e, state: n, label: t, error: r, helperText: i, prefixIcon: s, suffixIcon: a, id: l, ...c }, d) => {
    const p = it(), g = l ?? p;
    return /* @__PURE__ */ u("div", { className: "flex flex-col gap-1", children: [
      t && /* @__PURE__ */ o(
        "label",
        {
          htmlFor: g,
          className: "text-label-md font-medium font-ui text-text-weak",
          children: t
        }
      ),
      /* @__PURE__ */ u("div", { className: "relative flex items-center", children: [
        s && /* @__PURE__ */ o("span", { className: "absolute left-3 text-text-weakest", children: s }),
        /* @__PURE__ */ o(
          "input",
          {
            ref: d,
            id: g,
            className: _(
              Zt({ state: r ? "error" : n }),
              s && "pl-10",
              a && "pr-10",
              e
            ),
            "aria-invalid": !!r,
            "aria-describedby": r ? `${g}-error` : i ? `${g}-helper` : void 0,
            ...c
          }
        ),
        a && /* @__PURE__ */ o("span", { className: "absolute right-3 text-text-weakest", children: a })
      ] }),
      r && /* @__PURE__ */ o("p", { id: `${g}-error`, className: "text-label-sm font-ui text-semantic-danger", children: r }),
      !r && i && /* @__PURE__ */ o("p", { id: `${g}-helper`, className: "text-label-sm font-ui text-text-weakest", children: i })
    ] });
  }
);
Ut.displayName = "Input";
const er = xe("rounded-m font-ui", {
  variants: {
    surface: {
      default: "bg-surface-default",
      dim: "bg-surface-dim",
      "extra-dim": "bg-surface-extra-dim"
    },
    elevation: {
      flat: "",
      raised: "shadow-raised",
      overlay: "shadow-overlay"
    },
    padding: {
      none: "",
      sm: "p-3",
      md: "p-4",
      lg: "p-6"
    }
  },
  defaultVariants: {
    surface: "default",
    elevation: "flat",
    padding: "md"
  }
}), tr = Ce(
  ({ className: e, surface: n, elevation: t, padding: r, children: i, ...s }, a) => /* @__PURE__ */ o(
    "div",
    {
      ref: a,
      className: _(er({ surface: n, elevation: t, padding: r }), e),
      ...s,
      children: i
    }
  )
);
tr.displayName = "Card";
function rr({ items: e, activeId: n, onItemClick: t, header: r, footer: i, className: s }) {
  return /* @__PURE__ */ u(
    "nav",
    {
      className: _(
        "flex flex-col h-full w-20 bg-surface-dim border-r border-border-weak font-ui",
        s
      ),
      children: [
        r && /* @__PURE__ */ o("div", { className: "flex items-center justify-center py-4", children: r }),
        /* @__PURE__ */ o("div", { className: "flex flex-col items-center gap-2 flex-1 py-2", children: e.map((a) => {
          const l = a.id === n;
          return /* @__PURE__ */ u(
            "button",
            {
              onClick: () => t == null ? void 0 : t(a.id),
              className: _(
                "relative flex flex-col items-center justify-center gap-1",
                "w-full py-2 px-1",
                "text-label-sm transition-colors cursor-pointer",
                l ? "text-text-default font-medium" : "text-text-weak hover:text-text-default"
              ),
              children: [
                l && /* @__PURE__ */ o("span", { className: "absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-accent-primary rounded-pill" }),
                /* @__PURE__ */ o("span", { className: "text-[1.25rem]", children: a.icon }),
                /* @__PURE__ */ o("span", { className: "text-label-sm leading-label truncate max-w-full px-1", children: a.label })
              ]
            },
            a.id
          );
        }) }),
        i && /* @__PURE__ */ o("div", { className: "flex items-center justify-center py-4", children: i })
      ]
    }
  );
}
rr.displayName = "NavRail";
const or = ({ icon: e, label: n, isActive: t, onClick: r }) => {
  const [i, s] = at.useState(!1);
  return /* @__PURE__ */ o(
    "button",
    {
      onClick: r,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      title: n,
      "aria-label": n,
      "aria-current": t ? "page" : void 0,
      style: {
        width: 48,
        height: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        background: t ? "var(--ik-color-accent-primary-container)" : i ? "var(--ik-color-surface-dim)" : "transparent",
        borderRadius: "var(--ik-shape-br-xl)",
        cursor: "pointer",
        transition: "background 0.15s ease",
        color: t ? "var(--ik-color-accent-on-primary-container)" : "var(--ik-color-text-weakest)",
        padding: 0
      },
      children: e
    }
  );
}, we = 0.1, nr = ({
  items: e = [],
  active: n,
  onSelect: t,
  footer: r,
  panelWidth: i,
  panel: s
}) => {
  const a = e.find((y) => y.id === n), l = s !== void 0 ? !!n : !!(a != null && a.panel || a != null && a.panelFooter), c = ce(l), d = c.current !== l;
  c.current = l;
  const p = l ? i !== void 0 ? i : "calc(100% - 52px)" : 0, g = i !== void 0 ? i : "100%", k = d ? `width ${we}s cubic-bezier(0.25, 0.1, 0.25, 1)` : "none";
  return /* @__PURE__ */ u("div", { style: { display: "flex", height: "100%", width: "100%", flexShrink: 0 }, children: [
    /* @__PURE__ */ u(
      "nav",
      {
        role: "navigation",
        "aria-label": "Main navigation",
        style: {
          width: 52,
          height: "100%",
          background: "var(--ik-color-surface-default)",
          borderRight: "1px solid var(--ik-color-border-weak)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 8,
          paddingBottom: 12,
          flexShrink: 0,
          boxSizing: "border-box"
        },
        children: [
          /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 2,
                flex: 1,
                alignItems: "center"
              },
              children: e.map((y) => /* @__PURE__ */ o(
                or,
                {
                  icon: y.icon,
                  label: y.label,
                  isActive: n === y.id,
                  onClick: () => t == null ? void 0 : t(y.id)
                },
                y.id
              ))
            }
          ),
          r && /* @__PURE__ */ o("div", { style: { marginTop: "auto", display: "flex", flexDirection: "column", gap: 2 }, children: r })
        ]
      }
    ),
    /* @__PURE__ */ o(
      "aside",
      {
        style: {
          width: p,
          height: "100%",
          background: "var(--ik-color-surface-default)",
          borderRight: l ? "1px solid var(--ik-color-border-weak)" : "none",
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
          overflow: "hidden",
          boxSizing: "border-box",
          transition: k
        },
        children: /* @__PURE__ */ o(
          "div",
          {
            style: {
              width: g,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ o(
              "div",
              {
                style: {
                  width: g,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  opacity: l ? 1 : 0,
                  transform: l ? "translateX(0)" : "translateX(-8px)",
                  transition: `opacity ${we}s ease-out, transform ${we}s ease-out`,
                  pointerEvents: l ? "auto" : "none"
                },
                children: s !== void 0 ? s : /* @__PURE__ */ u(te, { children: [
                  /* @__PURE__ */ o("div", { style: { flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }, children: a == null ? void 0 : a.panel }),
                  (a == null ? void 0 : a.panelFooter) && /* @__PURE__ */ o(
                    "div",
                    {
                      style: {
                        padding: "10px 12px",
                        borderTop: "1px solid var(--ik-color-border-weak)",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexShrink: 0,
                        background: "var(--ik-color-surface-default)"
                      },
                      children: a.panelFooter
                    }
                  )
                ] })
              }
            )
          }
        )
      }
    )
  ] });
};
function ar(e = 900) {
  const n = () => typeof window < "u" ? window.matchMedia(`(max-width: ${e}px)`).matches : !1, [t, r] = ae(n);
  return de(() => {
    if (typeof window > "u") return;
    const i = window.matchMedia(`(max-width: ${e}px)`), s = () => r(i.matches);
    return s(), i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, [e]), t;
}
const ir = ({ icon: e, label: n, isActive: t, badge: r, onClick: i }) => {
  const [s, a] = ae(!1);
  return /* @__PURE__ */ o(
    "button",
    {
      onClick: i,
      onTouchStart: () => a(!0),
      onTouchEnd: () => a(!1),
      onMouseDown: () => a(!0),
      onMouseUp: () => a(!1),
      onMouseLeave: () => a(!1),
      "aria-label": n,
      "aria-current": t ? "page" : void 0,
      style: {
        flex: "1 0 auto",
        minWidth: 56,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        background: t ? "var(--ik-color-accent-primary-container)" : s ? "var(--ik-color-surface-dim)" : "transparent",
        cursor: "pointer",
        padding: "4px 0 2px",
        WebkitTapHighlightColor: "transparent",
        transform: s ? "scale(0.95)" : "scale(1)",
        transition: "transform 0.08s ease, background 0.08s ease",
        position: "relative",
        touchAction: "manipulation",
        userSelect: "none"
      },
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "var(--ik-shape-br-xl)",
            background: "transparent",
            color: t ? "var(--ik-color-accent-on-primary-container)" : "var(--ik-color-text-weakest)",
            transition: "color 0.12s ease",
            position: "relative"
          },
          children: [
            e,
            r != null && r > 0 && /* @__PURE__ */ o(
              "span",
              {
                style: {
                  position: "absolute",
                  top: 2,
                  right: 0,
                  minWidth: 16,
                  height: 16,
                  borderRadius: "var(--ik-shape-br-pill, 999px)",
                  background: "var(--ik-color-accent-primary)",
                  color: "var(--ik-color-accent-on-primary)",
                  fontSize: 10,
                  fontWeight: 600,
                  font: "var(--ik-font-default-xs)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 4px",
                  lineHeight: 1,
                  boxSizing: "border-box"
                },
                children: r > 99 ? "99+" : r
              }
            )
          ]
        }
      )
    }
  );
}, sr = 0.1, lr = ({ items: e = [], active: n, onSelect: t, panel: r }) => {
  const i = !!n && r !== void 0;
  return /* @__PURE__ */ u(te, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        style: {
          opacity: i ? 1 : 0,
          pointerEvents: i ? "auto" : "none",
          transition: `opacity ${sr}s ease-out`
        },
        children: r
      }
    ),
    /* @__PURE__ */ o(
      "nav",
      {
        role: "navigation",
        "aria-label": "Main navigation",
        style: {
          width: "100%",
          background: "var(--ik-color-surface-default)",
          borderTop: "1px solid var(--ik-color-border-weak)",
          display: "flex",
          alignItems: "stretch",
          overflowX: "auto",
          overflowY: "hidden",
          flexWrap: "nowrap",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          height: 72,
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
          boxSizing: "content-box",
          flexShrink: 0
        },
        children: e.map((s) => /* @__PURE__ */ o(
          ir,
          {
            icon: s.icon,
            label: s.label,
            badge: s.badge,
            isActive: n === s.id,
            onClick: () => t == null ? void 0 : t(s.id)
          },
          s.id
        ))
      }
    )
  ] });
}, Vr = (e) => {
  var s;
  const n = e.mobile ?? ar(), t = ce(e.active ?? null), r = ce(!1);
  if (de(() => {
    n && e.active && (t.current = e.active);
  }), de(() => {
    var a;
    if (!r.current) {
      r.current = !0;
      return;
    }
    !n && t.current && ((a = e.onSelect) == null || a.call(e, t.current));
  }, [n]), n)
    return /* @__PURE__ */ o(lr, { ...e });
  const i = ((s = e.items) == null ? void 0 : s.map(({ id: a, icon: l, label: c }) => ({ id: a, icon: l, label: c }))) ?? [];
  return /* @__PURE__ */ o(
    nr,
    {
      items: i,
      active: e.active,
      onSelect: e.onSelect,
      footer: e.footer,
      panelWidth: e.panelWidth,
      panel: e.panel
    }
  );
}, cr = xe("flex flex-col font-ui", {
  variants: {
    gap: {
      sm: "gap-1",
      md: "gap-2",
      lg: "gap-4"
    }
  },
  defaultVariants: {
    gap: "md"
  }
});
function dr({
  items: e,
  renderItem: n,
  keyExtractor: t,
  alternating: r = !1,
  gap: i,
  className: s
}) {
  return /* @__PURE__ */ o("div", { className: _(cr({ gap: i }), s), children: e.map((a, l) => /* @__PURE__ */ o(
    "div",
    {
      className: _(
        "rounded-m",
        r && (l % 2 === 0 ? "bg-surface-default" : "bg-surface-dim")
      ),
      children: n(a, l)
    },
    t ? t(a, l) : l
  )) });
}
dr.displayName = "List";
function mr(e, n) {
  return e.name.toLowerCase().includes(n.toLowerCase());
}
function et(e, n, t, r) {
  var i;
  for (const s of e)
    (i = s.children) != null && i.length && (r === "all" ? (n.add(s.id), et(s.children, n, t + 1, r)) : r === "firstLevel" && t < 1 && n.add(s.id));
}
function ur(e, n = /* @__PURE__ */ new Set()) {
  var t;
  for (const r of e)
    (t = r.children) != null && t.length && (n.add(r.id), ur(r.children, n));
  return n;
}
function tt(e, n, t) {
  var s;
  let r = 0, i = 0;
  for (const a of e)
    if (i++, (s = a.children) != null && s.length) {
      const l = tt(a.children, n, t);
      (l === "all" || l === "some") && (t.add(a.id), r++);
    } else n.has(a.id) && r++;
  return r === i && i > 0 ? "all" : r > 0 ? "some" : "none";
}
function rt(e, n) {
  var t;
  for (const r of e) {
    if (r.id === n) return r;
    const i = (t = r.children) != null && t.length ? rt(r.children, n) : null;
    if (i) return i;
  }
  return null;
}
function ot(e, n = []) {
  var t;
  if (!((t = e.children) != null && t.length))
    return n.push(e), n;
  for (const r of e.children)
    ot(r, n);
  return n;
}
function Me(e, n = !0) {
  return [...e].sort((t, r) => {
    var a, l;
    const i = t.type === "folder" || !!((a = t.children) != null && a.length), s = r.type === "folder" || !!((l = r.children) != null && l.length);
    return i && !s ? -1 : !i && s ? 1 : n ? t.name.localeCompare(r.name) : 0;
  });
}
function fr(e, n) {
  const [t, r] = ae(e), [i, s] = ae(e), a = ce(!0);
  return de(() => {
    if (!n) {
      r(e), s(e);
      return;
    }
    if (a.current) {
      a.current = !1;
      return;
    }
    let l = null, c = null;
    return e ? (r(!0), c = requestAnimationFrame(() => {
      c = requestAnimationFrame(() => s(!0));
    })) : (s(!1), l = setTimeout(() => r(!1), 200)), () => {
      l && clearTimeout(l), c && cancelAnimationFrame(c);
    };
  }, [e, n]), { show: t, transitioning: i };
}
const hr = ({ expanded: e }) => /* @__PURE__ */ o("svg", { className: _("h-6 w-6 shrink-0 transition-transform duration-150 sm:h-4 sm:w-4", e && "rotate-90"), viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ o("path", { d: "M6 4l4 4-4 4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }), br = ({ expanded: e }) => /* @__PURE__ */ o("svg", { className: "h-7 w-7 shrink-0 text-accent-primary sm:h-5 sm:w-5", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: e ? /* @__PURE__ */ o("path", { d: "M6 14l1.45-2.9A2 2 0 019.24 10H20a2 2 0 011.94 2.5l-1.55 6a2 2 0 01-1.94 1.5H4a2 2 0 01-2-2V5a2 2 0 012-2h3.9a2 2 0 011.69.9l.81 1.2a2 2 0 001.67.9H18a2 2 0 012 2v2" }) : /* @__PURE__ */ o("path", { d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" }) }), pr = () => /* @__PURE__ */ u("svg", { className: "h-5 w-5 shrink-0 text-text-weakest sm:h-4 sm:w-4", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ o("path", { d: "M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" }),
  /* @__PURE__ */ o("path", { d: "M13 2v7h7" })
] }), xr = () => /* @__PURE__ */ u("svg", { className: "h-5 w-5 shrink-0 text-text-weak sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.5", children: [
  /* @__PURE__ */ o("path", { d: "M6.5 9.5a3 3 0 004.243 0l2-2a3 3 0 00-4.243-4.243L7.25 4.5", strokeLinecap: "round" }),
  /* @__PURE__ */ o("path", { d: "M9.5 6.5a3 3 0 00-4.243 0l-2 2a3 3 0 004.243 4.243L8.75 11.5", strokeLinecap: "round" })
] }), gr = ({ checked: e, indeterminate: n }) => /* @__PURE__ */ u("svg", { className: "block h-6 w-6 shrink-0 cursor-pointer sm:h-4 sm:w-4", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ o(
    "rect",
    {
      x: "1",
      y: "1",
      width: "14",
      height: "14",
      rx: "2",
      className: _(e || n ? "fill-accent-primary stroke-accent-primary" : "fill-none stroke-border-default"),
      strokeWidth: "1.5"
    }
  ),
  e && !n && /* @__PURE__ */ o("path", { d: "M4 8l2.5 2.5L12 5", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
  n && /* @__PURE__ */ o("line", { x1: "4", y1: "8", x2: "12", y2: "8", stroke: "white", strokeWidth: "2", strokeLinecap: "round" })
] }), vr = () => /* @__PURE__ */ u("svg", { className: "h-5 w-5 shrink-0 animate-spin text-accent-primary sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", children: [
  /* @__PURE__ */ o("circle", { cx: "8", cy: "8", r: "6", stroke: "currentColor", strokeWidth: "2", opacity: "0.25" }),
  /* @__PURE__ */ o("path", { d: "M14 8a6 6 0 00-6-6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
] }), yr = () => /* @__PURE__ */ u(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-blue-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("rect", { x: "2", y: "2", width: "12", height: "12", rx: "1.5" }),
      /* @__PURE__ */ o("line", { x1: "2", y1: "6", x2: "14", y2: "6" }),
      /* @__PURE__ */ o("line", { x1: "6", y1: "6", x2: "6", y2: "14" })
    ]
  }
), wr = {
  dwg: { label: "DWG", bodyFill: "#E8724A", foldFill: "#F4B8A3", textFill: "#5C1A00" },
  dxf: { label: "DXF", bodyFill: "#F5A623", foldFill: "#FCDFA6", textFill: "#5C3D00" },
  ifc: { label: "IFC", bodyFill: "#89C4E9", foldFill: "#D3EAF8", textFill: "#00357F" },
  xml: { label: "XML", bodyFill: "#D4A04A", foldFill: "#F0DCA0", textFill: "#5C3D00" },
  gt: { label: "GT", bodyFill: "#967ADC", foldFill: "#D1C4F1", textFill: "#2E1A5E" },
  shp: { label: "SHP", bodyFill: "#48CFAD", foldFill: "#B5EDE0", textFill: "#0A4A3A" },
  pdf: { label: "PDF", bodyFill: "#DA4453", foldFill: "#F0B3B8", textFill: "#4A0A12" }
}, kr = () => /* @__PURE__ */ u("svg", { className: "h-5 w-5 shrink-0 text-semantic-danger sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ o("circle", { cx: "8", cy: "8", r: "6" }),
  /* @__PURE__ */ o("line", { x1: "8", y1: "5", x2: "8", y2: "9" }),
  /* @__PURE__ */ o("circle", { cx: "8", cy: "11.5", r: "0.75", fill: "currentColor", stroke: "none" })
] }), Nr = ({ config: e }) => /* @__PURE__ */ u("svg", { className: "h-7 w-7 shrink-0 sm:h-5 sm:w-5", viewBox: "0 0 16 16", fill: "none", children: [
  /* @__PURE__ */ o("path", { d: "M4 1.5A1.5 1.5 0 015.5 0h4.586a1.5 1.5 0 011.06.44l2.354 2.353a1.5 1.5 0 01.44 1.061V14.5A1.5 1.5 0 0112.5 16h-7A1.5 1.5 0 014 14.5v-13z", fill: "none", stroke: e.bodyFill, strokeWidth: "1.5", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M10.086 0.146V3.5a1 1 0 001 1H14.44", fill: "none", stroke: e.foldFill, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o(
    "rect",
    {
      x: "1.5",
      y: "8",
      width: "13",
      height: "7",
      rx: "1",
      fill: "white",
      stroke: e.textFill,
      strokeWidth: "0.6"
    }
  ),
  /* @__PURE__ */ o(
    "text",
    {
      x: "8",
      y: "11.5",
      textAnchor: "middle",
      dominantBaseline: "middle",
      fontFamily: "Inter Tight, Arial, sans-serif",
      fontSize: e.label.length <= 2 ? "5.8" : "4.8",
      fontWeight: "700",
      letterSpacing: "0.2",
      fill: e.textFill,
      children: e.label
    }
  )
] }), Cr = () => /* @__PURE__ */ u(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-green-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("path", { d: "M1 13l4-8 3 5 2.5-3L15 13H1z" }),
      /* @__PURE__ */ o("path", { d: "M5 5l3 5" }),
      /* @__PURE__ */ o("path", { d: "M10.5 7L8 10" })
    ]
  }
), Ar = () => /* @__PURE__ */ u(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-yellow-800 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("path", { d: "M2 5h5v6h5" }),
      /* @__PURE__ */ o("circle", { cx: "7", cy: "8", r: "1.5" }),
      /* @__PURE__ */ o("line", { x1: "12", y1: "8", x2: "14", y2: "8" }),
      /* @__PURE__ */ o("line", { x1: "12", y1: "11", x2: "14", y2: "11" }),
      /* @__PURE__ */ o("rect", { x: "11.5", y: "7", width: "3", height: "5", rx: "0.5" })
    ]
  }
), zr = () => /* @__PURE__ */ u(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-red-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("path", { d: "M2 13C4 9 6 4 8 4s4 5 6 9" }),
      /* @__PURE__ */ o("line", { x1: "5", y1: "8.5", x2: "11", y2: "8.5", strokeDasharray: "1.5 1.5" })
    ]
  }
), Mr = {
  drawing: yr,
  surface: Cr,
  pipe: Ar,
  alignment: zr
}, Ir = {
  dwg: "drawing",
  dxf: "drawing"
};
function nt(e) {
  const n = e.lastIndexOf(".");
  if (n !== -1)
    return e.slice(n + 1).toLowerCase();
}
function Lr(e) {
  if (e.layerType) return e.layerType;
  const n = nt(e.name);
  if (n)
    return Ir[n];
}
function Fr(e, n) {
  var r;
  if (e.icon) return e.icon;
  const t = e.type ?? ((r = e.children) != null && r.length ? "folder" : "file");
  if (t === "file") {
    const i = nt(e.name);
    if (i) {
      const a = wr[i];
      if (a) return /* @__PURE__ */ o(Nr, { config: a });
    }
    const s = Lr(e);
    if (s) {
      const a = Mr[s];
      if (a) return /* @__PURE__ */ o(a, {});
    }
  }
  switch (t) {
    case "folder":
      return /* @__PURE__ */ o(br, { expanded: n });
    case "link":
      return /* @__PURE__ */ o(xr, {});
    default:
      return /* @__PURE__ */ o(pr, {});
  }
}
function Ne(e, n, t) {
  var r;
  return t(e, n) ? !0 : ((r = e.children) == null ? void 0 : r.some((i) => Ne(i, n, t))) ?? !1;
}
function ge({
  node: e,
  level: n,
  selectedId: t,
  onSelect: r,
  onDoubleClick: i,
  onContextMenu: s,
  checkable: a,
  checkedIds: l,
  indeterminateIds: c,
  onToggleCheck: d,
  loadingIds: p,
  expandedIds: g,
  onToggleExpand: k,
  filterText: y,
  matchesFilter: A,
  renderLabel: N,
  hideEmptyFolders: w,
  animated: z = !1
}) {
  var S;
  const F = !!((S = e.children) != null && S.length), M = g.has(e.id), { show: O, transitioning: G } = fr(M, z), C = t != null && e.id == t, W = l.has(e.id) || c.has(e.id), b = !1, I = p.has(e.id), j = J(() => y ? Ne(e, y, A) : !0, [e, y, A]), $ = J(() => Me(e.children ?? []), [e.children]);
  return !j || w && F && e.children.filter((P) => !y || Ne(P, y, A)).length === 0 ? null : /* @__PURE__ */ u("div", { role: "treeitem", "aria-expanded": F ? M : void 0, children: [
    /* @__PURE__ */ u(
      "div",
      {
        className: _(
          "relative flex cursor-pointer select-none items-center gap-1.5 overflow-hidden rounded-s px-2 py-1 transition-colors duration-100",
          "hover:bg-surface-dim active:bg-surface-extra-dim",
          "max-sm:gap-3 max-sm:rounded-m max-sm:px-4 max-sm:py-3",
          C && "bg-surface-dim font-medium text-text-default"
        ),
        style: {
          paddingLeft: `calc(${n} * 16px + 8px)`
        },
        onClick: (R) => {
          if (R.shiftKey && a && F) {
            d == null || d(e, { deep: !0 });
            return;
          }
          F && k(e.id), r == null || r(e);
        },
        onDoubleClick: () => i == null ? void 0 : i(e),
        onContextMenu: (R) => {
          s && (R.preventDefault(), R.stopPropagation(), s(e, { x: R.pageX, y: R.pageY }));
        },
        children: [
          n > 0 && /* @__PURE__ */ u(te, { children: [
            /* @__PURE__ */ o(
              "span",
              {
                className: "pointer-events-none absolute bg-accent-primary-container",
                style: {
                  left: `${n * 16 + 2}px`,
                  top: "-8px",
                  bottom: "50%",
                  width: "1.5px"
                }
              }
            ),
            /* @__PURE__ */ o(
              "span",
              {
                className: "pointer-events-none absolute bg-accent-primary-container",
                style: {
                  left: `${n * 16 + 2}px`,
                  top: "50%",
                  width: "6px",
                  height: "1.5px"
                }
              }
            )
          ] }),
          C && /* @__PURE__ */ o("span", { className: "absolute inset-y-1.5 left-0 w-1 rounded-pill bg-accent-primary" }),
          /* @__PURE__ */ o(
            "span",
            {
              className: _("relative z-10 flex h-6 w-6 shrink-0 items-center justify-center sm:h-4 sm:w-4", !F && "invisible"),
              onClick: (R) => {
                R.stopPropagation(), F && k(e.id);
              },
              children: F && /* @__PURE__ */ o(hr, { expanded: M })
            }
          ),
          a && /* @__PURE__ */ o(
            "span",
            {
              className: "relative z-10 flex shrink-0 items-center",
              onClick: (R) => {
                R.stopPropagation(), d == null || d(e, R.shiftKey ? { deep: !0 } : void 0);
              },
              children: /* @__PURE__ */ o(gr, { checked: W, indeterminate: b })
            }
          ),
          I ? /* @__PURE__ */ o(vr, {}) : Fr(e, M),
          /* @__PURE__ */ o("span", { className: _("min-w-0 flex-1 truncate select-none text-body-md leading-body", I && "opacity-loading"), children: N ? N(e) : e.name }),
          e.secondaryIcon && /* @__PURE__ */ o("span", { className: "shrink-0 text-text-weakest", children: e.secondaryIcon }),
          e.error && /* @__PURE__ */ o("span", { className: "shrink-0", title: e.error, children: /* @__PURE__ */ o(kr, {}) })
        ]
      }
    ),
    F && (z ? O : M) && /* @__PURE__ */ o(
      "div",
      {
        role: "group",
        className: _(
          z && "grid transition-[grid-template-rows] duration-200 ease-out",
          z && (G ? "grid-rows-[1fr]" : "grid-rows-[0fr]")
        ),
        children: /* @__PURE__ */ o("div", { className: _(z && "overflow-hidden"), children: $.map((R) => /* @__PURE__ */ o(
          ge,
          {
            node: R,
            level: n + 1,
            selectedId: t,
            onSelect: r,
            onDoubleClick: i,
            onContextMenu: s,
            checkable: a,
            checkedIds: l,
            indeterminateIds: c,
            onToggleCheck: d,
            loadingIds: p,
            expandedIds: g,
            onToggleExpand: k,
            filterText: y,
            matchesFilter: A,
            renderLabel: N,
            hideEmptyFolders: w,
            animated: z
          },
          R.id
        )) })
      }
    )
  ] });
}
ge.displayName = "TreeNodeRow";
function jr({
  nodes: e,
  selectedId: n,
  onNodeSelected: t,
  onDoubleClick: r,
  onContextMenu: i,
  checkable: s,
  checkedIds: a,
  indeterminateIds: l,
  loadingIds: c,
  expandedIds: d,
  onToggleExpand: p,
  onToggleCheck: g,
  filterText: k,
  matchesFilter: y,
  renderLabel: A,
  hideEmptyFolders: N,
  sortChildren: w
}) {
  const z = J(() => Me(e, w), [e, w]);
  return /* @__PURE__ */ o("div", { className: "flex min-h-0 flex-1 flex-col px-0 pb-1", children: /* @__PURE__ */ o("div", { role: "tree", className: "min-h-0 flex-1 overflow-auto", children: z.map((F) => /* @__PURE__ */ o(
    ge,
    {
      node: F,
      level: 0,
      selectedId: n,
      onSelect: t,
      onDoubleClick: r,
      onContextMenu: i,
      checkable: s,
      checkedIds: a,
      indeterminateIds: l,
      onToggleCheck: g,
      loadingIds: c,
      expandedIds: d,
      onToggleExpand: p,
      filterText: k,
      matchesFilter: y,
      renderLabel: A,
      hideEmptyFolders: N,
      animated: !0
    },
    F.id
  )) }) });
}
function Rr({
  nodes: e,
  selectedId: n,
  onNodeSelected: t,
  onDoubleClick: r,
  onContextMenu: i,
  checkable: s,
  checkedIds: a,
  indeterminateIds: l,
  loadingIds: c,
  expandedIds: d,
  onToggleExpand: p,
  onToggleCheck: g,
  filterText: k,
  matchesFilter: y,
  renderLabel: A,
  hideEmptyFolders: N,
  selectOnNavigate: w = !1
}) {
  const [z, F] = ae([]), M = z.length ? rt(e, z[z.length - 1]) : null, O = Me((M == null ? void 0 : M.children) ?? e), G = J(() => /* @__PURE__ */ new Set(), []), C = ne(
    (j) => {
      d.has(j.id) || p(j.id), F(($) => [...$, j.id]);
    },
    [d, p]
  ), W = ne(
    (j) => {
      var $;
      ($ = j.children) != null && $.length && (C(j), !w) || t == null || t(j);
    },
    [C, t, w]
  ), b = ne((j) => {
  }, []), I = ne(() => {
    F((j) => j.slice(0, -1));
  }, []);
  return /* @__PURE__ */ u(te, { children: [
    M && /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", alignSelf: "flex-start", textAlign: "left" }, className: "border-b border-border-weak bg-surface-dim px-4 py-3", children: [
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          onClick: I,
          "aria-label": "Go back",
          style: { marginRight: 12, flexShrink: 0 },
          className: "flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-m border-0 bg-accent-primary text-text-white",
          children: /* @__PURE__ */ o("svg", { className: "h-6 w-6", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", children: /* @__PURE__ */ o("path", { d: "M15 18l-6-6 6-6" }) })
        }
      ),
      /* @__PURE__ */ u(
        "button",
        {
          type: "button",
          style: { display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 8, minWidth: 0, flex: "1 1 auto", textAlign: "left" },
          className: "border-0 bg-transparent",
          onClick: () => t == null ? void 0 : t(M),
          children: [
            /* @__PURE__ */ o("svg", { className: "h-8 w-8 shrink-0 text-accent-primary", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: /* @__PURE__ */ o("path", { d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" }) }),
            /* @__PURE__ */ o("span", { className: "truncate text-title-md font-medium text-text-default", children: A ? A(M) : M.name })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { className: "overflow-auto px-0 pb-1", role: "tree", children: O.map((j) => /* @__PURE__ */ o(
      ge,
      {
        node: j,
        level: 0,
        selectedId: n,
        onSelect: W,
        onDoubleClick: r,
        onContextMenu: i,
        checkable: s,
        checkedIds: a,
        indeterminateIds: l,
        onToggleCheck: g,
        loadingIds: c,
        expandedIds: G,
        onToggleExpand: b,
        filterText: k,
        matchesFilter: y,
        renderLabel: A,
        hideEmptyFolders: N
      },
      j.id
    )) })
  ] });
}
function Sr(e = 639) {
  const n = () => typeof window < "u" ? window.matchMedia(`(max-width: ${e}px)`).matches : !1, [t, r] = ae(n);
  return de(() => {
    if (typeof window > "u") return;
    const i = window.matchMedia(`(max-width: ${e}px)`), s = () => r(i.matches);
    return s(), i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, [e]), t;
}
function Tr({
  nodes: e,
  treeData: n,
  showRoot: t = !0,
  selectedId: r,
  onNodeSelected: i,
  onDoubleClick: s,
  onContextMenu: a,
  checkable: l = !1,
  checkedIds: c,
  onNodeChecked: d,
  onNodeUnchecked: p,
  loadingIds: g,
  expandOnStart: k = "firstLevel",
  expandedIds: y,
  onExpandedIdsChange: A,
  filterText: N = "",
  matchesFilter: w = mr,
  renderLabel: z,
  hideEmptyFolders: F = !1,
  sortChildren: M = !0,
  selectOnNavigate: O = !1,
  className: G,
  propagateCheckbox: C
}) {
  const W = n ?? e ?? [], b = y !== void 0, [I, j] = ae(() => {
    const m = /* @__PURE__ */ new Set();
    return et(W, m, 0, k), m;
  }), $ = J(() => b ? new Set(y) : I, [b, y, I]), S = J(() => new Set(c ?? []), [c]), R = J(() => new Set(g ?? []), [g]), P = J(() => {
    const m = /* @__PURE__ */ new Set();
    return tt(W, S, m), m;
  }, [W, S]), X = ne(
    (m) => {
      const K = (Z) => {
        const q = new Set(Z);
        return q.has(m) ? q.delete(m) : q.add(m), q;
      };
      if (b && A !== void 0) {
        A(Array.from(K(new Set(y))));
        return;
      }
      j((Z) => K(Z));
    },
    [b, y, A]
  ), V = ne(
    (m, K) => {
      var q, se;
      const Z = S.has(m.id) || P.has(m.id);
      if (K != null && K.deep && ((q = m.children) != null && q.length)) {
        const T = ot(m), L = T.every((H) => S.has(H.id));
        T.forEach((H) => {
          L ? p == null || p(H) : S.has(H.id) || d == null || d(H);
        });
        return;
      }
      if ((se = m.children) != null && se.length && C !== !1) {
        const T = m.children.filter((L) => {
          var H;
          return !((H = L.children) != null && H.length);
        });
        Z ? T.forEach((L) => {
          S.has(L.id) && (p == null || p(L));
        }) : T.forEach((L) => {
          S.has(L.id) || d == null || d(L);
        });
        return;
      }
      S.has(m.id) ? p == null || p(m) : d == null || d(m);
    },
    [S, P, d, p, C]
  ), Y = ne(
    (m) => {
      i == null || i(m);
    },
    [i]
  ), x = Sr(), B = J(() => {
    var m;
    return t || W.length !== 1 ? W : ((m = W[0]) == null ? void 0 : m.children) ?? [];
  }, [t, W]);
  return /* @__PURE__ */ o("div", { className: _("flex h-full min-h-[200px] min-w-[200px] flex-col overflow-hidden rounded-l bg-surface-default font-ui text-body-md leading-body text-text-default", G), children: x ? /* @__PURE__ */ o(
    Rr,
    {
      nodes: B,
      selectedId: r,
      onNodeSelected: i,
      onDoubleClick: s,
      onContextMenu: a,
      checkable: l,
      checkedIds: S,
      indeterminateIds: P,
      loadingIds: R,
      expandedIds: $,
      onToggleExpand: X,
      onToggleCheck: V,
      filterText: N,
      matchesFilter: w,
      renderLabel: z,
      hideEmptyFolders: F,
      selectOnNavigate: O
    }
  ) : /* @__PURE__ */ o(
    jr,
    {
      nodes: B,
      selectedId: r,
      onNodeSelected: Y,
      onDoubleClick: s,
      onContextMenu: a,
      checkable: l,
      checkedIds: S,
      indeterminateIds: P,
      loadingIds: R,
      expandedIds: $,
      onToggleExpand: X,
      onToggleCheck: V,
      filterText: N,
      matchesFilter: w,
      renderLabel: z,
      hideEmptyFolders: F,
      sortChildren: M
    }
  ) });
}
Tr.displayName = "Tree";
const Br = ({ size: e = 24 }) => {
  const n = "M12 1 C12 6 17 12 23 12 C17 12 12 18 12 23 C12 18 7 12 1 12 C7 12 12 6 12 1 Z";
  return /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-2 -2 28 28", width: e, height: e, fill: "none", style: { overflow: "visible" }, children: [
    /* @__PURE__ */ o("path", { fill: "#2196f3", stroke: "#2196f3", strokeWidth: 1.5, strokeLinejoin: "round", d: n }),
    /* @__PURE__ */ o("path", { fill: "#2196f3", stroke: "#2196f3", strokeWidth: 1.5, strokeLinejoin: "round", opacity: 0.95, transform: "translate(14, -3.5) scale(0.42)", d: n })
  ] });
};
Br.displayName = "AISparkleIcon";
const Wr = ({
  suggestion: e,
  onRemove: n,
  uploadProgress: t,
  isUploading: r,
  isSkipped: i,
  isPreSkipped: s,
  isAccepted: a,
  onToggleAccepted: l,
  strings: c
}) => {
  const d = r && t !== void 0 && t < 100, p = t === 100;
  return /* @__PURE__ */ o(
    "div",
    {
      className: `rounded-xl border p-3 transition-colors ${s ? "bg-semantic-warning-container border-yellow-200" : p && !i ? "bg-semantic-success-container border-green-200" : a ? "bg-surface-default border-blue-300" : "bg-surface-default border-border-weak"}`,
      children: /* @__PURE__ */ u("div", { className: "flex items-start gap-2.5", children: [
        l && /* @__PURE__ */ o(
          "input",
          {
            type: "checkbox",
            checked: a && !s,
            onChange: l,
            disabled: r || s,
            title: c.selectForRefineTitle,
            className: "w-4 h-4 mt-0.5 accent-semantic-info cursor-pointer disabled:cursor-not-allowed shrink-0"
          }
        ),
        /* @__PURE__ */ o("i", { className: "iki iki-files text-[1.2em] opacity-50 mt-0.5 shrink-0" }),
        /* @__PURE__ */ u("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ o("div", { className: `text-body-sm font-medium truncate ${s ? "opacity-disabled" : ""}`, title: e.filename, children: e.filename }),
          e.folder_path && /* @__PURE__ */ u("div", { className: "mt-0.5 flex items-center gap-1 font-mono text-label-sm text-text-weakest", children: [
            /* @__PURE__ */ o("i", { className: "iki iki-folder text-semantic-info text-[0.9em]" }),
            e.folder_path
          ] }),
          s && !i && /* @__PURE__ */ u("div", { className: "mt-2 px-2.5 py-2 bg-surface-default/70 border border-yellow-200 rounded-l flex items-start gap-2", children: [
            /* @__PURE__ */ o("i", { className: "iki iki-warning text-semantic-warning shrink-0 mt-px" }),
            /* @__PURE__ */ u("span", { className: "text-body-sm text-text-weak", children: [
              /* @__PURE__ */ o("strong", { className: "text-semantic-on-warning-container", children: c.fileExistsTitle }),
              " — ",
              c.fileExistsDesc
            ] })
          ] }),
          d && /* @__PURE__ */ u("div", { className: "mt-2", children: [
            /* @__PURE__ */ o("div", { className: "text-label-sm text-text-weakest mb-1", children: c.uploadingStatus(t) }),
            /* @__PURE__ */ o("div", { className: "w-full h-1 bg-surface-extra-dim rounded-pill overflow-hidden", children: /* @__PURE__ */ o("div", { className: "h-full bg-semantic-info transition-[width] duration-300 ease-in-out", style: { width: `${t}%` } }) })
          ] }),
          p && !i && /* @__PURE__ */ u("div", { className: "text-label-sm text-semantic-success mt-1 flex items-center gap-1", children: [
            /* @__PURE__ */ o("i", { className: "iki iki-check" }),
            " ",
            c.uploadedStatus
          ] }),
          i && /* @__PURE__ */ o("div", { className: "text-label-sm text-semantic-warning mt-1", children: c.skippedStatus })
        ] }),
        !r && /* @__PURE__ */ o(
          "button",
          {
            className: "text-text-weakest hover:text-semantic-danger hover:bg-surface-dim p-1 rounded-l shrink-0 text-[1.2em] leading-none font-bold",
            onClick: () => n(e.filename),
            title: c.removeTitle,
            children: "×"
          }
        )
      ] })
    }
  );
}, $r = ({
  step: e,
  isMinimized: n,
  onToggleMinimized: t,
  onClose: r,
  error: i,
  isProcessing: s,
  isUploading: a,
  strings: l,
  selectedFiles: c,
  onFilesSelected: d,
  onRemoveFile: p,
  onAnalyze: g,
  suggestions: k,
  preSkippedFiles: y,
  skippedFiles: A,
  uploadProgress: N,
  selectedForRefine: w,
  onToggleSelectedForRefine: z,
  onRemoveFromResults: F,
  refinePrompt: M,
  onRefinePromptChange: O,
  onRefine: G,
  uploadableSuggestions: C,
  onBackToSelect: W,
  onContinueToConfirm: b,
  skippedCount: I,
  overallProgress: j,
  folderGroups: $,
  onUploadAll: S,
  onBackToResults: R
}) => {
  const P = ce(null), X = (x) => {
    const B = Array.from(x.target.files || []);
    B.length > 0 && d(B), x.target.value = "";
  }, V = (x) => {
    x.preventDefault(), x.stopPropagation();
  }, Y = (x) => {
    x.preventDefault(), x.stopPropagation();
    const B = Array.from(x.dataTransfer.files || []);
    B.length > 0 && d(B);
  };
  return /* @__PURE__ */ u(
    "div",
    {
      className: `bg-surface-default overflow-hidden transition-all duration-300 ease-in-out ${n ? "w-full rounded-xl shadow-[0_4px_16px_rgba(0,0,0,.15)]" : "rounded-xl shadow-[0_12px_40px_rgba(15,17,28,.18)] max-h-[85vh] flex flex-col"}`,
      children: [
        /* @__PURE__ */ u("div", { className: `flex items-center gap-3 border-b border-border-weak bg-surface-default ${n ? "librarian-header py-3 px-4 cursor-move" : "px-5 py-4"}`, children: [
          /* @__PURE__ */ o("i", { className: "iki iki-ai text-[1.6em] opacity-60 shrink-0" }),
          /* @__PURE__ */ u("div", { className: "flex-1", children: [
            /* @__PURE__ */ o("div", { className: "text-body-lg font-semibold leading-tight", children: l.title }),
            /* @__PURE__ */ o("div", { className: "text-label-sm text-text-weakest leading-tight", children: l.stepSubtitles[e] })
          ] }),
          /* @__PURE__ */ o(
            "i",
            {
              className: `iki ${n ? "iki-chevron-up" : "iki-chevron-down"} clickable opacity-50 hover:opacity-100 hover:bg-neutral-1000/5 py-1 px-2 rounded-m text-[1em]`,
              onClick: (x) => {
                x.stopPropagation(), t();
              },
              title: n ? l.expandTitle : l.minimizeTitle
            }
          ),
          /* @__PURE__ */ o(
            "i",
            {
              className: "iki iki-close clickable opacity-50 hover:opacity-100 hover:bg-neutral-1000/5 py-1 px-2 rounded-m text-[1em]",
              onClick: (x) => {
                x.stopPropagation(), r();
              },
              title: l.closeTitle
            }
          )
        ] }),
        !n && /* @__PURE__ */ u(te, { children: [
          /* @__PURE__ */ u("div", { className: `flex-1 min-h-0 overflow-y-auto p-5 bg-surface-dim ${s ? "overlay-loading" : ""}`, children: [
            i && /* @__PURE__ */ o("div", { className: "mb-4 padded alert alert-danger", children: i }),
            e === "select" && /* @__PURE__ */ u("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: "rounded-xl border-2 border-dashed border-border-default bg-surface-default hover:bg-surface-dim transition-colors cursor-pointer text-center px-6 py-8",
                  onDragOver: V,
                  onDrop: Y,
                  onClick: () => {
                    var x;
                    return (x = P.current) == null ? void 0 : x.click();
                  },
                  children: [
                    /* @__PURE__ */ o("input", { ref: P, type: "file", multiple: !0, className: "hidden", onChange: X }),
                    /* @__PURE__ */ o("div", { className: "w-11 h-11 mx-auto mb-3 rounded-xl bg-surface-extra-dim flex items-center justify-center", children: /* @__PURE__ */ o("i", { className: "iki iki-upload text-[1.4em] opacity-60" }) }),
                    /* @__PURE__ */ o("div", { className: "text-body-md font-semibold mb-1", children: l.dragAndDrop }),
                    /* @__PURE__ */ o("div", { className: "text-body-sm text-text-weakest mb-3", children: l.orClickToBrowse }),
                    /* @__PURE__ */ o(
                      "button",
                      {
                        className: "bg-surface-default border border-border-default rounded-l px-4 py-1.5 text-body-sm font-medium hover:bg-surface-dim",
                        onClick: (x) => {
                          var B;
                          x.stopPropagation(), (B = P.current) == null || B.click();
                        },
                        children: l.browseFiles
                      }
                    )
                  ]
                }
              ),
              c.length > 0 && /* @__PURE__ */ u("div", { className: "flex-column gap-1.5", children: [
                /* @__PURE__ */ o("div", { className: "text-body-sm font-semibold text-text-weak", children: l.filesAdded(c.length) }),
                /* @__PURE__ */ o("div", { className: "flex-column gap-1.5 max-h-48 overflow-y-auto", children: c.map((x, B) => /* @__PURE__ */ u(
                  "div",
                  {
                    className: "flex items-center gap-2.5 px-3 py-2 rounded-l border border-border-weak bg-surface-default hover:border-border-default transition-colors",
                    children: [
                      /* @__PURE__ */ o("i", { className: "iki iki-files text-[1.1em] opacity-50 shrink-0" }),
                      /* @__PURE__ */ o("span", { className: "flex-1 text-body-sm font-medium truncate", children: x.name }),
                      /* @__PURE__ */ o(
                        "button",
                        {
                          className: "text-text-weakest hover:text-semantic-danger hover:bg-surface-dim p-1 rounded-m shrink-0 text-[1.2em] leading-none font-bold",
                          onClick: () => p(B),
                          title: l.resultItem.removeTitle,
                          children: "×"
                        }
                      )
                    ]
                  },
                  B
                )) })
              ] })
            ] }),
            e === "results" && /* @__PURE__ */ u("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ o("div", { className: "text-body-sm text-text-weakest italic", children: l.resultsInstructions }),
              /* @__PURE__ */ o("div", { className: "flex-column gap-2 max-h-64 overflow-y-auto", children: k.map((x) => /* @__PURE__ */ o(
                Wr,
                {
                  suggestion: x,
                  onRemove: F,
                  uploadProgress: N[x.filename],
                  isUploading: a,
                  isSkipped: A.has(x.filename),
                  isPreSkipped: y.has(x.filename),
                  isAccepted: w.has(x.filename),
                  onToggleAccepted: () => z(x.filename),
                  strings: l.resultItem
                },
                x.filename
              )) }),
              /* @__PURE__ */ u("div", { className: "rounded-xl border border-border-weak bg-surface-default p-3.5", children: [
                /* @__PURE__ */ u("div", { className: "flex items-center gap-2 mb-2", children: [
                  /* @__PURE__ */ o("i", { className: "iki iki-chat text-[1.1em] opacity-50" }),
                  /* @__PURE__ */ o("span", { className: "text-body-sm font-semibold", children: l.refineTitle }),
                  /* @__PURE__ */ o("span", { className: "text-label-sm text-text-weakest", children: l.refineHint })
                ] }),
                /* @__PURE__ */ o(
                  "textarea",
                  {
                    placeholder: l.refinePlaceholder,
                    value: M,
                    onChange: (x) => O(x.currentTarget.value),
                    rows: 2,
                    className: "w-full border border-border-default rounded-l px-2.5 py-2 text-body-sm resize-y outline-none focus:border-border-focus"
                  }
                ),
                /* @__PURE__ */ o("div", { className: "flex justify-end mt-2", children: /* @__PURE__ */ o(
                  "button",
                  {
                    className: `border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium ${w.size === 0 || !M.trim() || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-surface-dim"}`,
                    onClick: G,
                    disabled: w.size === 0 || !M.trim() || s,
                    children: s ? l.refining : l.refineButton
                  }
                ) })
              ] })
            ] }),
            e === "confirm" && /* @__PURE__ */ u("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ u("div", { className: `grid gap-3 ${I > 0 ? "grid-cols-2" : "grid-cols-1"}`, children: [
                /* @__PURE__ */ u("div", { className: "rounded-xl border border-green-200 bg-semantic-success-container px-4 py-3.5", children: [
                  /* @__PURE__ */ u("div", { className: "flex items-center gap-2 mb-1", children: [
                    /* @__PURE__ */ o("i", { className: "iki iki-check text-semantic-success" }),
                    /* @__PURE__ */ o("div", { className: "text-label-sm font-semibold text-semantic-on-success-container uppercase tracking-wider", children: l.willBeUploaded })
                  ] }),
                  /* @__PURE__ */ o("div", { className: "text-2xl font-bold", children: C.length }),
                  /* @__PURE__ */ o("div", { className: "text-label-sm text-text-weak mt-0.5", children: l.filesLabel })
                ] }),
                I > 0 && /* @__PURE__ */ u("div", { className: "rounded-xl border border-border-weak bg-surface-default px-4 py-3.5", children: [
                  /* @__PURE__ */ u("div", { className: "flex items-center gap-2 mb-1", children: [
                    /* @__PURE__ */ o("i", { className: "iki iki-minus text-text-weakest" }),
                    /* @__PURE__ */ o("div", { className: "text-label-sm font-semibold text-text-weakest uppercase tracking-wider", children: l.skipped })
                  ] }),
                  /* @__PURE__ */ o("div", { className: "text-2xl font-bold", children: I }),
                  /* @__PURE__ */ o("div", { className: "text-label-sm text-text-weak mt-0.5", children: l.alreadyExist })
                ] })
              ] }),
              a && /* @__PURE__ */ u("div", { className: "rounded-xl border border-blue-200 bg-semantic-info-container px-4 py-3.5", children: [
                /* @__PURE__ */ u("div", { className: "flex items-center justify-between mb-2", children: [
                  /* @__PURE__ */ o("span", { className: "text-body-sm font-medium text-blue-700", children: l.uploadingTitle }),
                  /* @__PURE__ */ u("span", { className: "text-body-sm text-semantic-info font-semibold", children: [
                    j,
                    "%"
                  ] })
                ] }),
                /* @__PURE__ */ o("div", { className: "w-full h-1.5 bg-blue-200 rounded-pill overflow-hidden", children: /* @__PURE__ */ o("div", { className: "h-full bg-blue-500 rounded-pill transition-[width] duration-300 ease-in-out", style: { width: `${j}%` } }) }),
                /* @__PURE__ */ o("div", { className: "text-label-sm text-blue-500 mt-1.5", children: l.uploadProgress(
                  C.filter((x) => (N[x.filename] ?? 0) === 100).length,
                  C.length
                ) })
              ] }),
              Object.keys($).length > 0 && /* @__PURE__ */ u("div", { className: "rounded-xl border border-border-weak bg-surface-default overflow-hidden", children: [
                /* @__PURE__ */ o("div", { className: "px-3.5 py-2.5 bg-surface-dim border-b border-border-weak text-label-sm font-semibold text-text-weakest uppercase tracking-wider", children: l.destinationMap }),
                /* @__PURE__ */ o("div", { className: "py-1 max-h-48 overflow-y-auto", children: Object.entries($).map(([x, B]) => /* @__PURE__ */ u("div", { className: "px-3.5 py-2", children: [
                  /* @__PURE__ */ u("div", { className: "flex items-center gap-2 font-mono text-body-sm text-text-weak mb-1", children: [
                    /* @__PURE__ */ o("i", { className: "iki iki-folder text-semantic-info" }),
                    /* @__PURE__ */ o("span", { className: "font-medium text-text-default", children: x })
                  ] }),
                  /* @__PURE__ */ o("div", { className: "ml-5 flex-column gap-0.5", children: B.map((m) => /* @__PURE__ */ o("div", { className: "font-mono text-label-sm text-text-weak", children: m.filename }, m.filename)) })
                ] }, x)) })
              ] })
            ] }),
            e === "done" && /* @__PURE__ */ u("div", { className: "py-10 text-center", children: [
              /* @__PURE__ */ o("div", { className: "w-16 h-16 rounded-round bg-semantic-success-container mx-auto mb-4 flex items-center justify-center", children: /* @__PURE__ */ o("i", { className: "iki iki-check text-semantic-success text-[2em]" }) }),
              /* @__PURE__ */ o("div", { className: "text-title-md font-semibold mb-1.5", children: l.allDone }),
              /* @__PURE__ */ o("div", { className: "text-body-sm text-text-weakest mb-5", children: l.doneMessage(C.length) }),
              /* @__PURE__ */ o(
                "button",
                {
                  className: "border border-border-default bg-surface-default rounded-l px-4 py-2 text-body-sm font-medium hover:bg-surface-dim",
                  onClick: r,
                  children: l.close
                }
              )
            ] })
          ] }),
          e !== "done" && /* @__PURE__ */ u("div", { className: "px-5 py-3.5 border-t border-border-weak bg-surface-default flex items-center justify-between gap-3", children: [
            /* @__PURE__ */ o("button", { className: "text-text-weak hover:bg-surface-dim px-3 py-1.5 rounded-l text-body-sm font-medium transition-colors", onClick: r, children: l.cancel }),
            /* @__PURE__ */ u("div", { className: "flex gap-2", children: [
              e === "results" && /* @__PURE__ */ u(
                "button",
                {
                  className: "border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium hover:bg-surface-dim flex items-center gap-1.5",
                  onClick: W,
                  children: [
                    /* @__PURE__ */ o("i", { className: "iki iki-chevron-left" }),
                    " ",
                    l.back
                  ]
                }
              ),
              e === "confirm" && /* @__PURE__ */ u(
                "button",
                {
                  className: `border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${a ? "opacity-disabled cursor-not-allowed" : "hover:bg-surface-dim"}`,
                  onClick: () => !a && R(),
                  children: [
                    /* @__PURE__ */ o("i", { className: "iki iki-chevron-left" }),
                    " ",
                    l.back
                  ]
                }
              ),
              e === "select" && /* @__PURE__ */ u(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${c.length === 0 || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: g,
                  disabled: c.length === 0 || s,
                  children: [
                    s ? l.analyzing : l.analyzeButton,
                    !s && /* @__PURE__ */ o("i", { className: "iki iki-chevron-right" })
                  ]
                }
              ),
              e === "results" && /* @__PURE__ */ u(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${C.length === 0 || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: b,
                  disabled: C.length === 0 || s,
                  children: [
                    l.continueButton(C.length),
                    /* @__PURE__ */ o("i", { className: "iki iki-chevron-right" })
                  ]
                }
              ),
              e === "confirm" && /* @__PURE__ */ o(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${a || C.length === 0 ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: S,
                  disabled: a || C.length === 0,
                  children: a ? /* @__PURE__ */ u(te, { children: [
                    /* @__PURE__ */ o("span", { className: "w-3 h-3 border-[1.5px] border-text-white border-t-transparent rounded-round inline-block animate-spin" }),
                    l.uploading
                  ] }) : /* @__PURE__ */ o(te, { children: l.uploadButton(C.length) })
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
}, _r = ({ input: e, onInputChange: n, onSearch: t, onClose: r, isSearching: i, error: s, results: a, onFileClick: l, strings: c }) => {
  const d = c;
  return /* @__PURE__ */ u("div", { className: "card padded flex-column gap-half max-h-[70vh] overflow-hidden shadow-[0_10px_40px_rgba(0,0,0,0.3)]", children: [
    /* @__PURE__ */ u("div", { className: "relative", children: [
      /* @__PURE__ */ o("i", { className: "iki iki-ai absolute left-3 top-3 text-[1.6em] opacity-50" }),
      /* @__PURE__ */ o(
        "input",
        {
          autoFocus: !0,
          type: "text",
          placeholder: d.placeholder,
          className: "text-[1.5em] p-[10px] h-auto pl-[50px] w-full",
          value: e,
          onChange: (p) => n(p.currentTarget.value)
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { className: "italic opacity-70", children: /* @__PURE__ */ o("span", { children: d.description }) }),
    /* @__PURE__ */ u("div", { className: "flex-row gap-half", children: [
      /* @__PURE__ */ o("button", { onClick: t, disabled: !(e != null && e.trim()) || i, children: i ? d.searchingButton : d.searchButton }),
      /* @__PURE__ */ o("button", { onClick: r, children: d.cancelButton })
    ] }),
    /* @__PURE__ */ u("div", { className: i ? "overlay-loading overflow-y-auto flex-1 min-h-0" : "overflow-y-auto flex-1 min-h-0", children: [
      s && /* @__PURE__ */ o("div", { className: "padded alert alert-danger", children: s }),
      a && /* @__PURE__ */ o("div", { className: "flex-column gap", children: a.matches && a.matches.length > 0 ? /* @__PURE__ */ u(te, { children: [
        a.needs_clarification && /* @__PURE__ */ o("div", { className: "padded alert alert-warning", children: d.needsClarification }),
        /* @__PURE__ */ u("div", { className: "flex-column", children: [
          /* @__PURE__ */ u("header", { className: "py-2 font-bold", children: [
            d.foundFilesLabel,
            " (",
            a.matches.length,
            ")"
          ] }),
          a.matches.map((p) => /* @__PURE__ */ u(
            "div",
            {
              className: "clickable flex p-3 rounded cursor-pointer transition-colors duration-150 hover:bg-black/5",
              onClick: () => l(p),
              children: [
                /* @__PURE__ */ o("div", { className: "w-10 h-10 flex items-center justify-center mr-3 text-[1.5em] opacity-70", children: /* @__PURE__ */ o("i", { className: "iki iki-files" }) }),
                /* @__PURE__ */ u("div", { className: "flex-column gap-[5px]", children: [
                  /* @__PURE__ */ o("div", { className: "flex-row font-medium text-[1.05em]", children: p.file_name }),
                  p.folder_path && /* @__PURE__ */ o("div", { className: "text-[0.9em] opacity-70", children: p.folder_path })
                ] })
              ]
            },
            p.file_uuid
          ))
        ] })
      ] }) : /* @__PURE__ */ o("div", { className: "padded text-center", children: d.noResults }) }),
      !a && !i && !s && /* @__PURE__ */ o("div", { className: "padded text-center text-[1.1em] m-auto opacity-70", children: d.enterQuery })
    ] })
  ] });
};
export {
  Br as AISparkleIcon,
  $r as AiLibrarianPanel,
  _r as AiSearchPanel,
  Vr as BottomNav,
  Jt as Button,
  tr as Card,
  Ut as Input,
  Wr as LibrarianResultItem,
  dr as List,
  rr as NavRail,
  nr as SideNav,
  Tr as Tree,
  ge as TreeNodeRow,
  Qt as buttonVariants,
  er as cardVariants,
  _ as cn,
  ur as collectAllFolderIds,
  mr as defaultMatchesFilter,
  Zt as inputVariants,
  cr as listVariants
};
